// import { BalanceSheetNoneType } from "pages/Finance/Report/types"
import { BSData } from "../types"

const getTotalBalance = (element: BSData, data: Array<BSData>): number => {
  let totalBalance = 0

  const children = data?.filter((coa) => coa?.parent_id === element?.coa_id)
  children.forEach((child) => totalBalance += child.balance + getTotalBalance(child, data))

  return totalBalance
}

export const calculateParent = (data: Array<BSData>) => {
  return data?.map((element) => {
    const children = data?.filter((coa) => coa?.parent_id === element?.coa_id)

    if (!children.length) return element

    return { ...element, balance: getTotalBalance(element, data) }
  })
}
